/**
 * Utilidades para manejar fechas de cheques sin desfasaje por timezone.
 * Las fechas se almacenan con mediodía UTC para evitar que en zonas UTC-3
 * (ej. Argentina) la medianoche UTC se muestre como el día anterior.
 */

/**
 * Obtiene la fecha en formato YYYY-MM-DD a partir de cualquier valor de fecha.
 * Usa componentes UTC para evitar desfasaje al mostrar fechas cargadas desde BD.
 * @param {string|Date|undefined} value - Fecha como string "YYYY-MM-DD", ISO o objeto Date
 * @returns {string} - "YYYY-MM-DD" o '' si no hay valor
 */
export function formatDateForDisplay(value) {
  if (value === undefined || value === null || value === '') return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Formatea una fecha para guardar en la base de datos.
 * Usa mediodía UTC (12:00) para que en zonas UTC-3 la fecha no cambie de día.
 * @param {string|Date|undefined} value - Fecha como "YYYY-MM-DD", ISO o Date
 * @returns {string|null} - "YYYY-MM-DDTHH:mm:ss.sssZ" o null
 */
export function formatDateForDb(value) {
  if (value === undefined || value === null || value === '') return null;
  const d = new Date(value);
  if (isNaN(d.getTime())) return null;
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}T12:00:00.000Z`;
}
